import {
  toUtcTimestamp,
  wallClockToDisplayDate,
} from "../../../../utils/timezone";

export const applySuggestedScheduleToForm = ({
  data,
  currentTimezone,
  currentScheduledDate,
}) => {
  const updates = {};

  if (!data) {
    return updates;
  }

  if (currentScheduledDate == null && data.date && data.time) {
    const scheduledDate = wallClockToDisplayDate({
      date: data.date,
      time: data.time,
    });
    const utcMs = toUtcTimestamp({
      date: scheduledDate,
      timezone: currentTimezone,
    });

    if (scheduledDate && utcMs != null && utcMs > Date.now()) {
      updates.scheduledDate = scheduledDate;
    }
  }

  if (data.reason) {
    updates.reason = data.reason;
  }

  return updates;
};
